// extracted by mini-css-extract-plugin
module.exports = {"StyledTabCategoryDiv":"home-page_StyledTabCategoryDiv__7tJyY","StyledFeaturedMake":"home-page_StyledFeaturedMake__uYIgZ","tabs_category":"home-page_tabs_category__IoQ3v"};